import { urlMainAPI } from '@/global'

export default {
  /**
   * Executa o Atingir Metas via SSE streaming.
   * @param {Object} params - Parâmetros do request
   * @param {Object} options - { onIteration: fn, signal: AbortSignal }
   * @returns {Promise<Object>} Resultado final
   */
  async run (params, { onIteration, signal } = {}) {
    const tk = localStorage.getItem('tk')
    const maxRetries = 3

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      if (signal?.aborted) throw new DOMException('Aborted', 'AbortError')

      try {
        const response = await fetch(`${urlMainAPI}/dogoalseekstream`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(tk ? { Authorization: `bearer ${tk}` } : {})
          },
          body: JSON.stringify(params),
          signal
        })

        if (!response.ok) {
          throw new Error(`Atingir Metas falhou: ${response.status} ${response.statusText}`)
        }

        const reader = response.body.getReader()
        const decoder = new TextDecoder()
        let finalResult = null
        let buffer = ''

        while (true) {
          const { done, value } = await reader.read()
          if (done) break

          buffer += decoder.decode(value, { stream: true })
          const lines = buffer.split('\n')
          buffer = lines.pop() || ''

          for (const line of lines) {
            const trimmed = line.trim()
            if (!trimmed.startsWith('data: ')) continue
            try {
              const data = JSON.parse(trimmed.slice(6))
              if (data.type === 'iteration' && onIteration) {
                onIteration(data)
              } else if (data.type === 'result') {
                finalResult = data
              }
            } catch (e) {
              // ignora linhas malformadas
            }
          }
        }

        if (buffer.trim().startsWith('data: ')) {
          try {
            const data = JSON.parse(buffer.trim().slice(6))
            if (data.type === 'result') finalResult = data
          } catch (e) {}
        }

        if (finalResult !== null) return finalResult

        // Stream fechou sem resultado — simulador caiu durante a execução
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 1000))
          continue
        }
        return null
      } catch (e) {
        if (e.name === 'AbortError') throw e
        if (attempt < maxRetries) {
          await new Promise(resolve => setTimeout(resolve, 1000))
          continue
        }
        throw e
      }
    }
  }
}
